import React from "react";
import "./index.css";

/* Import imgs */
import stars from "../assets/stars.svg";
import logogoogle from "../assets/logogoogle.svg";

import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

const Reviews = () => {
  const listReview = [
    {
      id: 1,
      text: "Gracias Silver Star Collision!!! El servicio que Abel y Sebastián me proveyeron fue más allá de lo que esperaba. Muy profesionales y amables. Me ayudaron a reparar mis carros en corto tiempo y respondieron todas mis dudas. Definitivamente seguiré llevando mis vehículos a este negocio. Gracias",
      name: "Patricia M",
    },
    {
      id: 2,
      text: "Thank Abel to you and your all team you guys do a great job... I love the way you treat me and my car looks great, you definitely  gives me more than I was specting.. super recommended 👌🏻🤗 Thank u🙏🙏",
      name: "Madii Golcher",
    },
    {
      id: 3,
      text: "Tube un percance con mi auto, lo lleve al shop de Abel, una persona muy atenta, me consiguio un auto mientras se reparaba el mio, en una semana estubo listo, la reparacion quedo muy bien, excelente trabajo",
      name: "Misael Herrera",
    },
    {
      id: 4,
      text: "Atención 10/10 amigables, si te resuelven los problemas sin andarte con trabas, quedo bastante satisfecho con el trabajo y la rapidez con la que te resuelven, calidad garantizada  🫡 gracias chicos 🚘…",
      name: "MrSrBuddyRaccon Primero",
    },
  ];

  return (
    <div className="section">
      <div className="container-sm flex flexCol alignCenter">
        <h2 className="textCenter">
          We are the preferred choice in the Los Angeles, including San Fernando
          Valley.
        </h2>
        <img className="stars" src={stars} alt="Stars" />
        <img className="google" src={logogoogle} alt="Logo Google" />

        <Swiper
          modules={[Navigation]}
          spaceBetween={50}
          slidesPerView={1}
          navigation
          className="reviewSlider textCenter"
        >
          {listReview.map((item) => (
            <SwiperSlide key={item.id}>
              <p>{item.text}</p>
              <p className="bold">{item.name}</p>
            </SwiperSlide>
          ))}
        </Swiper>
        <a
          className="btn"
          href="https://www.google.com/maps/place/Silver+Star+Collision+Center/@34.2028183,-118.4276018,17z/data=!4m18!1m9!3m8!1s0x80c2972532598a4d:0xa36341e5fc2c970b!2sSilver+Star+Collision+Center!8m2!3d34.2028139!4d-118.4250269!9m1!1b1!16s%2Fg%2F11gjm2tdtr!3m7!1s0x80c2972532598a4d:0xa36341e5fc2c970b!8m2!3d34.2028139!4d-118.4250269!9m1!1b1!16s%2Fg%2F11gjm2tdtr?entry=ttu"
          target="_blank"
        >
          See More
        </a>
      </div>
    </div>
  );
};

export default Reviews;
